module.exports = __webpack_public_path__ + "fonts/Poppins-BlackItalic.16dc9819.ttf";